import { AuthenticationClient } from './client';
import { User } from './types';

const GFK_USER_PREFIX = 'oauth2|gfk-aad|';
const NIQ_USER_PREFIX = 'oauth2|niq-aad|';
export const STP_USER_PREFIX = 'oauth2|gfk-azure-b2c|';
const ALAND_ISLANDS_COUNTRY_CODE = 'AX';

const hasGfkUserPrefix = (userId?: string) => Boolean(userId?.startsWith(GFK_USER_PREFIX));
const hasNiqUserPrefix = (userId?: string) => Boolean(userId?.startsWith(NIQ_USER_PREFIX));

/**
 * @deprecated Check user.isInternalUser instead
 */
export const isGfkUser = (userId?: string): boolean => {
  userId = userId || AuthenticationClient.getInstance().getUser()?.userId;
  const isInternalUser = AuthenticationClient.getInstance().getUser()?.isInternalUser || false;
  return userId?.startsWith(GFK_USER_PREFIX) || isInternalUser;
};

export const isInternal = (user?: Partial<User>): boolean =>
  Boolean(user?.isInternalUser) || hasGfkUserPrefix(user?.userId) || hasNiqUserPrefix(user?.userId);

export const isProxyUser = (user?: Partial<User>): boolean =>
  !isInternal(user) && Boolean(user?.email?.endsWith('@gfk.com'));

export const isSTPUser = (userId: string) => userId.startsWith(STP_USER_PREFIX);

export const isTestUser = (countryCode: string) => countryCode === ALAND_ISLANDS_COUNTRY_CODE;

export const getUserId = (userSub?: string): string => userSub || global['analytics']?.user?.().id() || '';

export const isPreview = () => window.location.host.startsWith('preview');

export const shouldDisableAnalytics = () => localStorage.getItem('disable_analytics') === 'true';
